import useAxios from 'hooks/useAxios';

export const editTournament = async (id, tournament) => {
  const api = useAxios();
  try {
    return await api.patch(`/tournament/${id}`, tournament);
  } catch (err) {
    console.error(err);
    return {
      err
    };
  }
};
